"use client";
import React from "react";
import Image from "./webflow_modules/Basic/components/Image";

export function BelowHeroRightImage({
  image = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65b17e747b3990d7dab72e52_pet.jpg",
  show = true,
}) {
  return show ? (
    <Image
      alt={""}
      className={"image-16"}
      // @ts-ignore - User-defined custom attribute(s)
      fetchPriority={"high"}
      height={"auto"}
      loading={"lazy"}
      src={image}
      width={"auto"}
    />
  ) : null;
}
